import { formatMoney } from 'accounting-js';

export function formatEuros(price) {
    const formattersOptions = {
        symbol: '€',
        precision: 2,
        thousand: '.',
        decimal: ',',
    };
    return formatMoney(price, formattersOptions);
}
